import React, { useState, useEffect } from 'react';

const getContext = () => {
    return (!__SERVER__ && window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.context) || {};
};
/* istanbul ignore next */
const withPerformanceMeasurement = (WrappedComponent) => {
    const { enableJsProfiling } = getContext();

    if (!enableJsProfiling) {
        return WrappedComponent;
    }
    return function WithPerformanceMeasurement(props) {
        const [renderTime, setRenderTime] = useState(0);
        const renderStart = performance.now();

        useEffect(() => {
            const renderEnd = performance.now();
            const duration = renderEnd - renderStart;
            // const componentName = WrappedComponent.name;
            // console.log('Metrics ********', `${componentName}::${duration.toFixed(2)}`);
            setRenderTime(duration);
        }, []);

        return (
            <div>
                <WrappedComponent {...props} />
                <p>RT: {renderTime.toFixed(2)} ms</p>
            </div>
        );
    };
};

export default withPerformanceMeasurement;
